<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Public Holidays</h1>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <p class="text-xs-center">Public Holidays can be set for any date. They will not automatically be set for the same date in future years.</p>
                        <p class="text-xs-center">Orders can not be made for any date designated as a public holiday.</p>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Filter Public Holidays"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox
                            label="Future Only"
                            v-model="futureOnly"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn
                            color="success"
                            block
                            @click="editPublicHoliday({})"
                        >
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="publicHolidays"
                            :loading="loading"
                            :search="search"
                            must-sort
                            :rows-per-page-items="rowsPerPage"
                            :pagination.sync="pagination"
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID">
                                    <td>{{formatDate(props.item.Date)}}</td>
                                    <td>
                                        <v-btn
                                            color="warning"
                                            block
                                            @click="editPublicHoliday(props.item)"
                                        >
                                            Edit
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-dialog v-model="showEditDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark :disabled="saving" @click="cancelEditPublicHoliday">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title v-if="editedPublicHoliday && editedPublicHoliday.ID">Edit Public Holiday</v-toolbar-title>
                        <v-toolbar-title v-else>Add New Public Holiday</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-form ref="editForm" v-model="editPublicHolidayValid">
                        <v-layout class="dialog-content">
                            <v-flex xs12 md6 offset-md3>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-menu
                                            ref="datePickerMenu"
                                            :close-on-content-click="false"
                                            v-model="datePickerMenu"
                                            :nudge-right="40"
                                            lazy
                                            transition="scale-transition"
                                            offset-y
                                            full-width
                                            min-width="290px">
                                            <v-text-field
                                                clearable
                                                slot="activator"
                                                v-model="editedPublicHoliday.Date"
                                                label="Date"
                                                prepend-icon="event"
                                                hint="Date"
                                                :rules="[rules.required]"
                                                readonly
                                            ></v-text-field>
                                            <v-date-picker 
                                                v-model="editedPublicHoliday.Date"
                                                @input="datePickerMenu = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap class="dialog-action-buttons">
                                    <v-flex xs12 sm6>
                                        <v-btn block color="error" :disabled="saving" @click="cancelEditPublicHoliday">Cancel</v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-btn block color="success" :disabled="!editPublicHolidayValid" :loading="saving" @click="saveEditedPublicHoliday">Save</v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <error-alert :content="saveError" :display="saveError"></error-alert>
                                    </v-flex>
                                </v-layout>                            
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import formatters from "../../helpers/formatters";
import ErrorAlert from "../common/ErrorAlert";
import util from '@/services/util';

export default {
    components: {
        ErrorAlert
    },
    props: [
        
    ],
    data() {
        return {
            rowsPerPage: [20, 50, 100],
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "Date"
            },
            editedPublicHoliday: {},
            showEditDialog: false,
            editPublicHolidayValid: false,
            search: "",
            datePickerMenu: false,
            futureOnly: true,
            rules: validationRules.rules,
            headers: [
                {
                    text: "Date",
                    value: "Date"
                },
                {
                    text: "", // edit button
                    sortable: false
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.publicHolidayStore.loading;
        },
        loadError() {
            return this.$store.state.publicHolidayStore.loadError;
        },
        saving() {
            return this.$store.state.publicHolidayStore.saving;
        },
        saveError() {
            return this.$store.state.publicHolidayStore.saveError;
        },
        publicHolidays() {
            return this.$store.state.publicHolidayStore.publicHolidays.filter(pH => {
                if(this.futureOnly){
                    let publicHoliday = Date.parse(pH.Date);

                    let isFutureDate = Date.now() < publicHoliday;
                    if(!isFutureDate){
                        return false;
                    }
                }

                return true;
            });
        }
    },
    methods: {
        loadPublicHolidays() {
            this.$store.dispatch("publicHolidayStore/loadPublicHolidays");
        },
        editPublicHoliday(item) {
            this.$store.dispatch("publicHolidayStore/clearSaveError");

            // show which fields are mandatory when opening the edit form
            this.$refs.editForm.validate();

            this.editedPublicHoliday = Object.assign({}, item);

            if (this.editedPublicHoliday.Date) {
                this.editedPublicHoliday.Date = util.stripTimeFromDateString(this.editedPublicHoliday.Date);    
            }

            this.showEditDialog = true;
        },
        cancelEditPublicHoliday() {
            this.showEditDialog = false;
            this.editedPublicHoliday = {};
        },
        saveEditedPublicHoliday() {
            var that = this;

            let publicHoliday = Object.assign({}, this.editedPublicHoliday);
            delete publicHoliday.FormattedDate;

            this.$store.dispatch("publicHolidayStore/savePublicHoliday", {
                publicHoliday: publicHoliday,
                finally: function() {
                    if (that.$store.state.publicHolidayStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditPublicHoliday();
                    }
                }
            });
        },
        formatDate(dateString) {
            return formatters.formatDate(dateString);
        }
    },
    created() {
        this.loadPublicHolidays();
    }
};
</script>

<style>
    
</style>
